import { useState } from "react";
import { SelectDevelopmentView } from "../../components/input/SelectDevelopmentView";
import AlertMessage, { AlertLevel } from "../../components/AlertMessage";
import RtkqResultViewer from "../../components/RtkqResultViewer";
import ManagePeerReviewGroups from "../peerReviewGroups/ManagePeerReviewGroup";
import { useManageReviewGroupsPageQuery } from "../peerReviewGroups/peerReviewGroupsApiSlice";

export default function TeacherPeerReviews() {
	const [view, setView] = useState<string>("table");
	const [alertMessage, setAlertMessage] = useState("");
	const [alertLevel, setAlertLevel] = useState(AlertLevel.Info);

	const reviewGroupsResult = useManageReviewGroupsPageQuery();
	const reviewGroupsData = reviewGroupsResult.data;

	const handleAlert = (message: string, level?: AlertLevel) => {
		setAlertMessage(message);
		setAlertLevel(level ?? AlertLevel.Info);
	};

	return (
		<section className="peerReview">
			<div className="flex justify-between">
				<div className="w-3/4">
					<h1>Peer Review Groups</h1>
				</div>
				<SelectDevelopmentView
					value={view}
					setValue={(v) => setView(v as string)}
					simpleListBoxId="viewFilter"
					options={[
						{ value: "table", label: "Tables" },
						{ value: "raw", label: "Raw Data" },
					]}
					fieldClasses="w-64 print:hidden"
				/>
			</div>

			<p className="mt-4">
				Welcome to the Peer Review page! From this page, you can assign students to peer
				review groups.
			</p>

			<AlertMessage
				className="my-4"
				type={alertLevel}
				message={alertMessage}
				showIcon={true}
				onClear={() => handleAlert("")}
			/>

			{view === "table" && (
				<ManagePeerReviewGroups data={reviewGroupsData} setAlert={handleAlert} />
			)}
			{view === "raw" && (
				<RtkqResultViewer heading="Manage Groups" result={reviewGroupsResult} />
			)}
		</section>
	);
}
